"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _values = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/values"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _config = _interopRequireDefault(require("../../../../targets/cord_eurofh_teams/config.js"));

var _reflux = _interopRequireDefault(require("reflux"));

var _UserProfile = _interopRequireDefault(require("./UserProfile.scss"));

var _QuizStrings = require("./QuizStrings");

var _AlertHelper = require("../../../helpers/AlertHelper");

var _CordovaHelper = require("../../../helpers/CordovaHelper");

var _UserService = _interopRequireWildcard(require("./services/UserService"));

var _UserLogsService = _interopRequireDefault(require("./services/UserLogsService"));

var _DataStore = _interopRequireWildcard(require("../../../KESI2/Stores/DataStore2"));

var _EquizzerActions = _interopRequireDefault(require("./actions/EquizzerActions"));

var _ErrorHelper = require("../../../helpers/ErrorHelper");

var _DataStoreComponent2 = _interopRequireDefault(require("../DataStoreComponent/DataStoreComponent2"));

var _QuizHomeStyle = require("./styles/QuizHomeStyle");

var _ThemeStore = _interopRequireDefault(require("../ThemeStore/ThemeStore2"));

var _DeviceInfoHelper = _interopRequireDefault(require("../../../helpers/DeviceInfoHelper"));

var _Constants = require("../../constants/Constants");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var UserProfile = /*#__PURE__*/function (_DataStoreComponent) {
  (0, _inherits2["default"])(UserProfile, _DataStoreComponent);

  var _super = _createSuper(UserProfile);

  function UserProfile(props) {
    var _thisSuper, _this;

    (0, _classCallCheck2["default"])(this, UserProfile);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setB64Image", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(b64) {
        var imgSrc, userAuth, userId, response, currentSubjectId, currentSubject;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                imgSrc = "data:image/jpg;base64,".concat(b64);
                _context.next = 3;
                return _this.props.getAuthToken();

              case 3:
                userAuth = _context.sent;

                _this.props.onSetUserImage(imgSrc);

                userId = _this.props.userInfo.id;
                _context.prev = 6;
                _context.next = 9;
                return _UserService["default"].saveCurrentUserProfilePicture(userId, imgSrc, userAuth);

              case 9:
                response = _context.sent;

                _this.setState({
                  imgSrc: imgSrc
                });

                _EquizzerActions["default"].setUser(response, 'setB64Image');

                if (response.points) {
                  _EquizzerActions["default"].setUserPoints(response.points);
                } else if (response.subjects) {
                  currentSubjectId = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_SUBJECT_ID);
                  currentSubject = response.subjects.find(function (singleSubject) {
                    return singleSubject.id === currentSubjectId;
                  });

                  if (currentSubject.points) {
                    _EquizzerActions["default"].setUserPoints(currentSubject.points);
                  }
                }

                _context.next = 19;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context["catch"](6);
                console.log(_context.t0); // const okButton = {
                //   label: getString('OK'),
                // }

                setTimeout(function () {
                  (0, _AlertHelper.showAlertWithOptions)({
                    html: (0, _ErrorHelper.getErrorMessage)(_context.t0),
                    title: (0, _QuizStrings.getString)('ERROR'),
                    centeredContent: true
                  }); // showWideAlertHtml(getErrorMessage(error), getString('ERROR'), true, [okButton])
                }, 0);

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[6, 15]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "changeProfilePic", function () {
      if (_DeviceInfoHelper["default"].isBrowser()) {
        // no profile image change in browsers
        // TODO: Rebuild to use file input
        // TODO: Check if file input works in diginale app
        return;
      }

      var setB64Image = _this.setB64Image;
      var galleryButton = {
        label: (0, _QuizStrings.getString)('FROM_GALLERY'),
        callback: function () {
          var _callback = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
            var picture;
            return _regenerator["default"].wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    _context2.prev = 0;
                    _context2.next = 3;
                    return (0, _CordovaHelper.takePictureFromGallery)();

                  case 3:
                    picture = _context2.sent;

                    if (picture) {
                      setB64Image(picture);
                    } // LOG: user events


                    _UserLogsService["default"].postProfilePicLog(_this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER].id, 'GALLERY');

                    _context2.next = 11;
                    break;

                  case 8:
                    _context2.prev = 8;
                    _context2.t0 = _context2["catch"](0);
                    console.log(_context2.t0);

                  case 11:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2, null, [[0, 8]]);
          }));

          function callback() {
            return _callback.apply(this, arguments);
          }

          return callback;
        }()
      };
      var cameraButton = {
        label: (0, _QuizStrings.getString)('FROM_CAMERA'),
        callback: function () {
          var _callback2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
            var picture;
            return _regenerator["default"].wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    _context3.prev = 0;
                    _context3.next = 3;
                    return (0, _CordovaHelper.takePictureWithCamera)(250, 250);

                  case 3:
                    picture = _context3.sent;

                    if (picture) {
                      setB64Image(picture); // LOG: user events

                      _UserLogsService["default"].postProfilePicLog(_this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER].id, 'CAMERA');
                    }

                    _context3.next = 10;
                    break;

                  case 7:
                    _context3.prev = 7;
                    _context3.t0 = _context3["catch"](0);
                    console.log(_context3.t0);

                  case 10:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3, null, [[0, 7]]);
          }));

          function callback() {
            return _callback2.apply(this, arguments);
          }

          return callback;
        }()
      }; // const cancelButton = {
      //   label: getString('CANCEL'),
      //   callback: () => {
      //   },
      // }

      (0, _AlertHelper.showAlertWithOptions)({
        html: (0, _QuizStrings.getString)('CHOOSE_IMAGE_SOURCE_TEXT'),
        title: (0, _QuizStrings.getString)('CHOOSE_IMAGE_SOURCE_TITLE'),
        centeredContent: true,
        buttons: [cameraButton, galleryButton // cancelButton
        ]
      }); // showWideAlertHtml(
      //   getString('CHOOSE_IMAGE_SOURCE_TEXT'),
      //   getString('CHOOSE_IMAGE_SOURCE_TITLE'),
      //   true,
      //   [cameraButton,
      //     galleryButton
      //     // cancelButton
      //   ]
      // )
    });
    _this.state = {
      imgSrc: null
    };
    (0, _get2["default"])((_thisSuper = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(UserProfile.prototype)), "setDataStorePaths", _thisSuper).call(_thisSuper, [_DataStore.DATA_STORE_PATHS.QD_USER, _DataStore.DATA_STORE_PATHS.QD_USER_AUTH, _DataStore.DATA_STORE_PATHS.QD_USER_POINTS, _DataStore.DATA_STORE_PATHS.QD_MY_TOURNAMENT, _DataStore.DATA_STORE_PATHS.QD_MY_TEAM_NAME, _DataStore.DATA_STORE_PATHS.QD_ALL_GAME, _DataStore.DATA_STORE_PATHS.QD_TOURNAMENT_TEAM_POINTS, _DataStore.DATA_STORE_PATHS.QD_GROUP_HIDE_FEEDBACK]);
    return _this;
  }

  (0, _createClass2["default"])(UserProfile, [{
    key: "renderUserPicture",
    value: function renderUserPicture() {
      if (this.props.tournamentMode) {
        return null;
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _UserProfile["default"].imageContainer
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _UserProfile["default"].profileThumb
      }, /*#__PURE__*/_react["default"].createElement("img", {
        alt: "img",
        onClick: this.changeProfilePic,
        src: this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER].picture ? this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER].picture : _UserService.DEFAULT_IMAGE
      })));
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.state.data) {
        return null;
      }

      var nickname = this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER] ? this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER].nickname : '';
      var groupLine = this.props.tournamentMode ? this.state.data[_DataStore.DATA_STORE_PATHS.QD_MY_TOURNAMENT].name : this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER].playgroup;
      var points;

      if (this.props.tournamentMode && this.state.data[_DataStore.DATA_STORE_PATHS.QD_MY_TOURNAMENT] && this.state.data[_DataStore.DATA_STORE_PATHS.QD_MY_TOURNAMENT]['teams']) {
        var teams = (0, _values["default"])(this.state.data[_DataStore.DATA_STORE_PATHS.QD_MY_TOURNAMENT]['teams']);
        var team1 = teams[0];
        var team2 = teams[1];
        var team1Points = team1.points;
        var team2Points = team2.points;
        var winnerTakesItAll = this.state.data[_DataStore.DATA_STORE_PATHS.QD_GROUP_WINNER_TAKES_IT_ALL];

        if (!winnerTakesItAll) {
          // const runningGames = this.state.data[DATA_STORE_PATHS.QD_ALL_GAME] || []
          // runningGames.forEach(game => {
          //   console.log('game', game)
          //   if (game.hasOwnProperty('tournament')) {
          //     const team1ChallengerCheck = team1.members.find(user => user.id === game.challenger)
          //     if (team1ChallengerCheck) {
          //       team1Points += game.challengerPoints
          //       team2Points += game.opponentPoints
          //     }
          //     else {
          //       team2Points += game.challengerPoints
          //       team1Points += game.opponentPoints
          //     }
          //   }
          // })
          var teamPoints = this.state.data[_DataStore.DATA_STORE_PATHS.QD_TOURNAMENT_TEAM_POINTS];
          console.log('teamPoints', teamPoints);

          if (teamPoints) {
            team1Points = teamPoints[team1.name];
            team2Points = teamPoints[team2.name];
          }
        }

        var userTeamName = this.state.data[_DataStore.DATA_STORE_PATHS.QD_MY_TEAM_NAME];
        var dynamicStyles = (0, _QuizHomeStyle.getStyles)(this.state);
        points = /*#__PURE__*/_react["default"].createElement("div", {
          className: this.props.tournamentMode ? _UserProfile["default"].pointsTournament : _UserProfile["default"].points
        }, /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            width: '45%',
            display: 'inline-block'
          }
        }, /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            color: dynamicStyles.homeStyle.color
          },
          className: userTeamName === team1.name ? _UserProfile["default"].userTeamName : _UserProfile["default"].teamName
        }, team1.name), /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            border: "1px solid ".concat(dynamicStyles.homeStyle.color)
          },
          className: window.innerHeight > _Constants.MIN_TABLET_LENGTH ? _UserProfile["default"].teamPointsContainerTablet : _UserProfile["default"].teamPointsContainer
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: userTeamName === team1.name ? _UserProfile["default"].userTeamPoints : _UserProfile["default"].teamPoints
        }, team1Points))), /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            width: '10%',
            display: 'inline-block',
            verticalAlign: 'bottom',
            marginBottom: '18px'
          }
        }, /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            fontWeight: 'bold',
            fontSize: '45px',
            color: dynamicStyles.homeStyle.color
          }
        }, ':')), /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            width: '45%',
            display: 'inline-block'
          }
        }, /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            color: dynamicStyles.homeStyle.color
          },
          className: userTeamName === team2.name ? _UserProfile["default"].userTeamName : _UserProfile["default"].teamName
        }, team2.name), /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            border: "1px solid ".concat(dynamicStyles.homeStyle.color)
          },
          className: window.innerHeight > _Constants.MIN_TABLET_LENGTH ? _UserProfile["default"].teamPointsContainerTablet : _UserProfile["default"].teamPointsContainer
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: userTeamName === team2.name ? _UserProfile["default"].userTeamPoints : _UserProfile["default"].teamPoints
        }, team2Points))));
      } else {
        points = _config["default"].showStyledPointsInProfile ? /*#__PURE__*/_react["default"].createElement("div", {
          className: _UserProfile["default"].styledPoints
        }, this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER_POINTS] || 0, " Punkte") : /*#__PURE__*/_react["default"].createElement("div", null, this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER_POINTS] || 0, " Punkte");
      }

      console.log('Userprofile', this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER], nickname);
      var nicknameArray = nickname ? nickname.split(' ') : [];
      var firstName = nicknameArray.length > 1 ? nicknameArray[0] : nickname;
      var lastName = nicknameArray.length > 1 ? nicknameArray[1] : '';
      var feedbackHiddenByGroup = this.state.data[_DataStore.DATA_STORE_PATHS.QD_GROUP_HIDE_FEEDBACK];
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _UserProfile["default"].profileContainer
      }, this.renderUserPicture(), /*#__PURE__*/_react["default"].createElement("div", {
        className: this.props.tournamentMode ? _UserProfile["default"].infoContainerTournament : _UserProfile["default"].infoContainer,
        style: this.props.style
      }, /*#__PURE__*/_react["default"].createElement("div", null, this.props.tournamentMode ? "".concat(nickname, " (").concat(groupLine, ")") : _config["default"].sortPlayersByLastName ? /*#__PURE__*/_react["default"].createElement("p", null, firstName, /*#__PURE__*/_react["default"].createElement("br", null), lastName) : nickname), !this.props.tournamentMode && /*#__PURE__*/_react["default"].createElement("div", null, _config["default"].hideQDGroupInProfile ? null : groupLine), feedbackHiddenByGroup ? null : points));
    }
  }]);
  return UserProfile;
}(_DataStoreComponent2["default"]); // noinspection Eslint


UserProfile.propTypes = {
  onSetUserImage: _propTypes["default"].func.isRequired,
  style: _propTypes["default"].object,
  tournamentMode: _propTypes["default"].bool,
  getAuthToken: _propTypes["default"].func.isRequired
};
var _default = UserProfile;
exports["default"] = _default;